import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import CLocalizedTextStringStatic from '../../components/CLocalizedTextStringStatic';
import { PageRoutes } from '../../enums/enums';
import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../store/appSlice';

export default function PNotificationsOutlet() {
  const dispatch = useAppDispatch();
  const notificationsTitle = CLocalizedTextStringStatic('notifications.title');
  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([PageRoutes.NOTIFICATIONS_OUTLET, notificationsTitle]));

    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch, notificationsTitle]);
  return <Outlet />;
}
